import React, { useState, useEffect } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import 'animate.css';
import '../../Faqs/index.css';

import { topics } from '../../Faqs/Topics';

const Faqs = () => {
  const [show, setShow] = useState(false);
  const [active, setActive] = useState(0);
  const [visibleQuestion, setVisibleQuestion] = useState(0);

  const handleDropDown = () => {
    setShow(!show);
  };

  const chooseActiveTopic = i => () => {
    setActive(i);
    handleDropDown();
    setVisibleQuestion(0);
  };

  const chooseActiveQuestion = i => () => {
    setVisibleQuestion(visibleQuestion === i ? null : i);
  };

  useEffect(() => {
    document.body.classList.remove('no-overflow');
    document.body.classList.add('overflow');
  }, []);

  return (
    <div>
      <div className='faqsContainerHome'>
        <div className='aboutSectionHome'>
          <div className='aboutListHome'>
            <div>
              {topics.map((topic, i) => (
                <p key={i} onClick={chooseActiveTopic(i)} style={{ color: '#4A4A4A', fontFamily: i === active ? 'Gilroy-Bold' : 'Gilroy-Regular' }}>{topic.heading}</p>
              ))}
            </div>
          </div>
          <div className='dropHome'>
            <div className='aboutDropDownHome' onClick={handleDropDown}>
              <p className='mobileAboutHeaderHome'>{topics[active].heading}</p>
              <div className='toggleIconHome'>{show ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}</div>
            </div>
            {show && (
            <div className="animate__animated animate__fadeIn animate__delay-100s">
              {topics.map((topic, i) => (
                <p key={i} onClick={chooseActiveTopic(i)} style={{ color: i === active ? '#51B57C' : '#353535', fontWeight: i === active ? 'bold' : 'normal' }}>{topic.heading}</p>
              ))}
            </div>
            )}
          </div>
          <div>
            {topics[active].qna.map((qna, i) => (
              <div className='infoHome' key={i}>
                <div className='listContentHome' onClick={chooseActiveQuestion(i)}>
                  <p className='listHeadingHome'>{qna.question}</p>
                  <span className='listIconHome'>{visibleQuestion !== i ? <MdKeyboardArrowDown /> : <MdKeyboardArrowUp />}</span>
                </div>
                <p className={`listCaptionHome ${visibleQuestion === i ? 'question-container-open' : 'question-container-close'}`}>{qna.answer}</p>
                <div className='listDividerHome' />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
